import { render, staticRenderFns } from "./RowActions.vue?vue&type=template&id=6809e964&scoped=true&"
import script from "./RowActions.vue?vue&type=script&lang=js&"
export * from "./RowActions.vue?vue&type=script&lang=js&"
import style0 from "./RowActions.vue?vue&type=style&index=0&id=6809e964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809e964",
  null
  
)

export default component.exports